/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { DataEncryptionDialogModel, DataEncryptionModel } from '@app/cluster-management/types';
import { NodeApi } from '@app/core/services';
import Arn from 'aws-arn';
import { EMPTY, catchError, map, of, switchMap } from 'rxjs';

export const dataEncryptionDialogModelResolver: ResolveFn<DataEncryptionDialogModel> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const nodeApi: NodeApi = inject(NodeApi);
  const clusterId = route.paramMap.get('contextActionClusterId')!;
  return clusterId
    ? nodeApi.getNodeConfiguration(clusterId).pipe(
        switchMap(({ encryptionSpi }) =>
          encryptionSpi
            ? of(encryptionSpi).pipe(
                map(({ masterKeyName, roleArn, externalId }) => {
                  const { region, accountId } = Arn.parse(masterKeyName) as Arn;
                  const dataEncryption: DataEncryptionModel = {
                    enabled: true,
                    cmkArn: masterKeyName,
                    cmkRegion: region,
                    roleArn,
                    externalId,
                  };
                  return { ...dataEncryption, accountId, region, isCreateDialogMode: false };
                }),
              )
            : EMPTY,
        ),
        catchError(() => EMPTY),
      )
    : EMPTY;
};
